import { render, staticRenderFns } from "./StreamChatSendMessage.vue?vue&type=template&id=61066b2c&scoped=true&"
import script from "./StreamChatSendMessage.vue?vue&type=script&lang=ts&"
export * from "./StreamChatSendMessage.vue?vue&type=script&lang=ts&"
import style0 from "./StreamChatSendMessage.vue?vue&type=style&index=0&id=61066b2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61066b2c",
  null
  
)

export default component.exports